import React from 'react'
import { Box } from '@mui/material'
import { EmtTypography } from 'emt-components-v2'
import { formatPrice } from '@/utils/formatPrice'
import { PRODUCTS_MAP } from '@/hooks/usePetsitterPrice'

interface PriceUnitSummaryProps {
  total: number
  quantity: number
  productSlug?: string
  petsNumber: number
}

export const PriceUnitSummary: React.FC<PriceUnitSummaryProps> = ({ total, quantity, productSlug, petsNumber }) => {
  const product = PRODUCTS_MAP[productSlug as keyof typeof PRODUCTS_MAP]

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
      <EmtTypography variant="body2" color="greyGradient.light" fontWeight={400}>
        <span style={{ whiteSpace: 'nowrap' }}>
          {Math.max(quantity, 1)} {quantity > 1 ? product?.titlePlural : product?.title},
        </span>
        <span style={{ whiteSpace: 'nowrap' }}>{` ${Math.max(petsNumber, 1)} anima${
          petsNumber > 1 ? 'ux' : 'l'
        }`}</span>
      </EmtTypography>
      <EmtTypography variant="body2" color="greyGradient.light" fontWeight={400} textAlign="right">
        soit {formatPrice(total / Math.max(quantity, 1))}€ / {product?.title}
      </EmtTypography>
    </Box>
  )
}
